document.addEventListener('DOMContentLoaded', function() {
  const fadeItems = document.querySelectorAll('.custom-scroll-fade');
  
  if (fadeItems.length === 0) return;
  
  function updateOpacity() {
    const windowHeight = window.innerHeight;
    // 视口的 40% 位置（从顶部往下计算）
    const triggerPoint = windowHeight * 0.6;
    
    fadeItems.forEach(item => {
      const rect = item.getBoundingClientRect();
      // 元素顶部到视口顶部的距离
      const elementTop = rect.top;
      
      // 判断元素顶部是否已经到达或超过视口 40% 位置
      const hasReachedTrigger = elementTop <= triggerPoint;
      
      // 判断元素是否还在视口内（至少部分可见）
      const isVisible = rect.bottom > 0 && rect.top < windowHeight;
      
      // 如果元素顶部到达触发点 且 还在视口内 → 保持 1，否则 0.25
      const opacity = (hasReachedTrigger && isVisible) ? 1 : 0.25;
      
      item.style.opacity = opacity;
    });
  }
  
  let ticking = false;
  
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateOpacity();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  
  window.addEventListener('resize', updateOpacity);
  updateOpacity();
});